/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Spacer, Text } from "@nordcloud/gnui";
import styles from "~/assets/styles/Runbook.module.css";
import { Divider } from "~/components/Styled/Divider";
import { Application } from "~/models";

type Props = {
  application: Application;
};

function AutoPatcherPlans({ application }: Props) {
  return (
    <Divider>
      <Spacer height="1rem" />

      <Text isTitle weight="medium">
        AutoPatcher plans
      </Text>

      {application?.apPlans?.length < 1 ? (
        <Text mt={3}>No AutoPatcher plans</Text>
      ) : (
        <>
          <div className={styles.columnsContainer}>
            <span className={styles.tableHeader}>Customer name</span>
            <span className={styles.tableHeader}>Plan</span>
          </div>

          {application?.apPlans?.map((ap, index) => (
            <div key={index} className={styles.columnsContainer}>
              <p className={styles.tableElement}>{ap?.customerName}</p>
              <p className={styles.tableElement}>{ap?.plan}</p>
            </div>
          ))}
        </>
      )}
      <Spacer height="1rem" />
    </Divider>
  );
}

export { AutoPatcherPlans };
